import styles from './style.module.css';

// Step 30: the same message as before, centred in the dark panel.
export default function NoGrantDisplay() {
   return (
      <div className={styles.no_grant_displayed}>
         <h1 className={styles.no_grant_title}>
            Select a card on the right to display grant information
         </h1>
      </div>
   );
}
